import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './gallery-style.css'
// PhotoSwipe styles
import 'photoswipe/dist/photoswipe.css'
import dayjs from 'dayjs'
// Day.js
import customParseFormat from 'dayjs/plugin/customParseFormat'

// Translations
import 'locale/i18n'

// Module Federation
// import { setup } from '@lmc/common/loader'
// import CONSTANTS from 'utils/constants'

// Extend Day.js with custom format plugin
dayjs.extend(customParseFormat)

// Function to setup the application
const bootstrapApp = async () => {
  /* await setup({
    rostering: CONSTANTS.VITE_ROSTERING_MODULE_URL,
  }) */

  // After setup is complete, load the rest of the app
  const container = document.getElementById('root') as HTMLElement
  const root = createRoot(container)

  root.render(<App />)

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals()
}

// Initialise the application
bootstrapApp()
